var CartDiscountType;
(function(CartDiscountType) {
    CartDiscountType["PERCENT"] = "PERCENT";
    CartDiscountType["AMOUNT"] = "AMOUNT";
})(CartDiscountType || (CartDiscountType = {}));
function createCartDiscountError(type, originalError) {
    return {
        type,
        originalError: originalError instanceof Error ? originalError : new Error('UNKNOWN_ERROR')
    };
}

export { CartDiscountType, createCartDiscountError };
//# sourceMappingURL=index.js.map
